import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../constant/helpLinks"

const データ形式 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { dxfData: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="データ形式" helpURL={HELP_LINKS.データ形式}>
      <RadioGroup name={FIELD_NAMES.データ形式} selectedValue={values.dxfData} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.データ形式["ガーバーデータ 又はCADLUS Xデータ（.comp形式）"].value}>
            ガーバーデータ 又は{"\n"}CADLUS Xデータ（.comp形式）
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.データ形式.DXFデータ.value}>DXFデータ</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.dxfData} />
    </OneClickField>
  )
}

export default データ形式
